import { render } from "./VersionControlTreeItem.vue?vue&type=template&id=419504b1"
import script from "./VersionControlTreeItem.vue?vue&type=script&lang=js"
export * from "./VersionControlTreeItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__